import EmptyView                      from 'scripts/defa/basic/view-empty-view';
import SubscriptionPackageRadioButton from 'scripts/defa/subscription-packages/view-subscription-package-radio-button';

/**
 * defa.views.SubscriptionPackageCollectionView
 * A view to list several SubscriptionPackages with.
 * @version 1.2.0
 */
import CollectionView                 from 'scripts/poppet/collection-view';

const SubscriptionPackageCollectionView = CollectionView.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	childView: SubscriptionPackageRadioButton,
	emptyView: EmptyView,
	
	emptyViewOptions: function () {
		return this.options;
	},
	
	childViewOptions: function () {
		return {
			installer: this.options.installer || false,
			prepaid: this.options.prepaid || false,
		}
	},
	
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	/**
	 * Triggers when all objects are attached to the DOM, but before they are rendered.
	 * @void
	 */
	onRender: function () {
		// if there is only one model in the collection, expand that models view.
		if ( 1 === this.collection.length ) {
			this.selectSubscriptionPackage( this.children.findByIndex( 0 ) );
			
			// if there are more models, check if there is only one promoView, if there is, expand that models view.
		} else {
			
			let arrPromoViews = _.filter( this.children._views, function ( view ) {
				return view.model.get( 'promotionCode' ) !== '';
			} );
			
			if ( 1 === arrPromoViews.length ) {
				this.selectSubscriptionPackage( arrPromoViews[ 0 ] );
			}
		}
	},
	
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	/**
	 * Checks a specific radio button, expands it's view and triggers a selected event for the childView.
	 * @void
	 */
	selectSubscriptionPackage: function ( view ) {
		view.$el
			.addClass( 'checked' )
			.addClass( 'open' );
		
		view.$el.find( '[type=radio]' )
			.prop( 'checked', true );
		
		this.trigger( 'selected', view );
	},
	
} );

export default SubscriptionPackageCollectionView;